import { LoadableFactory } from '®shared/data';

import { currentUserWithUpdatedUserProfile } from './current-user-and-permissions';
import {
  CurrentUserActionTypes,
  CurrentUserActions,
} from './current-user.actions';
import {
  CURRENT_USER_INITIAL_STATE,
  CurrentUserState,
} from './current-user.state';

export function currentUserReducer(
  state: CurrentUserState,
  action: CurrentUserActions,
): CurrentUserState {
  switch (action.type) {
    case CurrentUserActionTypes.REQUEST_CURRENT_USER: {
      return { ...state, loadableUser: LoadableFactory.loading() };
    }
    case CurrentUserActionTypes.STORE_CURRENT_USER: {
      const { currentUser } = action.payload;
      return { ...state, loadableUser: LoadableFactory.loaded(currentUser) };
    }
    case CurrentUserActionTypes.UPDATE_CURRENT_USER_PROFILE: {
      if (!state.loadableUser.data) {
        return state;
      }
      const { userRecord } = action.payload;
      const currentUserAndPermissions = state.loadableUser.data;

      return {
        ...state,
        loadableUser: {
          ...state.loadableUser,
          data: currentUserWithUpdatedUserProfile(
            currentUserAndPermissions,
            userRecord,
          ),
        },
      };
    }
    case CurrentUserActionTypes.STORE_ACCESS_TOKEN: {
      const { accessToken } = action.payload;
      return { ...state, accessToken };
    }
    case CurrentUserActionTypes.LOG_OUT: {
      return CURRENT_USER_INITIAL_STATE;
    }
  }
  return state;
}
